import { API_BASE_URL } from "../../config";

async function fetchHousingPermitsData() {
  try {
    const response = await fetch(`${API_BASE_URL}/housingPermits`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching housing permits data:', error);
    return [];
  }
}

export const housingPermitsData = await fetchHousingPermitsData();